import { useEffect } from 'react'
import { Router, navigate } from "@reach/router"

import Events from './Events/Events'
import EventsWizard from './Events/Wizard/Wizard'
import Teams from './Teams/Teams'
import Home from './Home/Home'
import { Resource } from './Resource/Resource'
import { MigrationResults } from './Migration/MigrationResults'
import { isCartillaSubdomain, isQAEnvironment, isAppWiriSubdomain } from './utils/links'
import Cartilla404 from './components/Cartilla404'
import RootRedirect from './components/RootRedirect'
import LookupAppointments from './Events/LookupAppointments'

const {
  REACT_APP_ROOT_HOST
} = process.env

function App() {
  // Lógica de redirección: subdominios de wiri.la van a cartilla
  useEffect(() => {
    try {
      // Solo aplicar redirección si NO estamos en el subdominio de cartilla ni en app.wiri.la
      if (!isCartillaSubdomain() && !isAppWiriSubdomain()) {
        const hostname = window.location.hostname
        const pathname = window.location.pathname
        const search = window.location.search
        
        // Si es un subdominio de wiri.la, redirigir a cartilla
        if (hostname.includes('wiri.la') && hostname !== 'wiri.la' && hostname !== 'consumers.qa.wiri.la') {
          const [subdomain] = hostname.split('.')
          const cartillaDomain = isQAEnvironment() ? 'https://cartilla.qa.drapp.com.ar' : 'https://cartilla.drapp.com.ar'
          
          // Si el subdominio es 'app', NO redirigir (funciona como dominio principal)
          if (subdomain === 'app') {
            // app.wiri.la funciona como dominio principal, no redirigir
            return null
          } else {
            // Para otros subdominios (como demo, test, etc.), redirigir a equipos
            // Si la ruta es solo / o /equipos/{subdomain}, redirigir a /equipos/{subdomain}
            if (pathname === '/' || pathname === `/equipos/${subdomain}` || pathname.startsWith(`/equipos/${subdomain}/`)) {
              window.location.href = `${cartillaDomain}/equipos/${subdomain}${pathname !== '/' ? pathname.replace(`/equipos/${subdomain}`, '') : ''}${search}`
            } else {
              // Para otras rutas (como turnos), preservar la ruta completa
              window.location.href = `${cartillaDomain}${pathname}${search}`
            }
          }
          return null
        }
        
        // Lógica original para otros dominios (si existe)
        const hosts = REACT_APP_ROOT_HOST?.split(',') || []
        if (hosts.length > 0 && !hosts.includes(window.location.origin)) {
          const [id] = window.location.hostname.split('.')
          window.location.href = `${hosts[0]}/equipos/${id}`
          return null
        }
      } else {
        // Si estamos en un subdominio de cartilla (ej: demo.cartilla.qa.drapp.com.ar)
        // y estamos en la raíz (/), redirigir internamente a /equipos/demo
        const hostname = window.location.hostname
        const pathname = window.location.pathname
        
        if (pathname === '/' && hostname !== 'cartilla.qa.drapp.com.ar' && hostname !== 'cartilla.drapp.com.ar') {
          const [subdomain] = hostname.split('.')
          // Usar navigate para redirección interna sin refresh
          navigate(`/equipos/${subdomain}`, { replace: true })
          return null
        }
      }
    } catch (error) {
      console.error('❌ Error in redirection logic:', error)
    }
  })

  // Si estamos en el subdominio de cartilla, solo mostrar rutas específicas
  if (isCartillaSubdomain()) {
    return (
      <Router>
        <Teams path="equipos/:teamID/*" />
        <Events path="turnos/*" />
        <Resource path="profesional/:slug/:id/*" />
        <LookupAppointments path="consultar-turnos" />
        <EventsWizard path="*path" />
        <Cartilla404 path="/" />
        <Cartilla404 path="/ar" />
        <Cartilla404 path="/mx" />
        <Cartilla404 path="/ec" />
        <Cartilla404 path="/especialidad/*" />
        <Cartilla404 default />
      </Router>
    );
  }

  // Para otros dominios (incluyendo app.wiri.la), mostrar todas las rutas
  return (
    <Router>
      <MigrationResults path="/especialidad/:specialty" />
      <Teams path="equipos/:teamID/*" />
      <Events path="turnos/*" />
      <Resource path="profesional/:slug/:id/*" />
      <LookupAppointments path="consultar-turnos" />
      <RootRedirect path="/" />
      <Home path="/mx" />
      <Home path="/ec" />
      <Home path="/ar" />
      <EventsWizard path="*path" />
    </Router>
  );
}

export default App;
